import { NgModule } from '@angular/core';
import { NzIconDirective } from './nz-icon.directive';

@NgModule({
  exports: [NzIconDirective],
  declarations: [NzIconDirective]
})
export class NzIconModule {}
